import script from "./BuyerList.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerList.vue?vue&type=script&setup=true&lang=js"

import "./BuyerList.vue?vue&type=style&index=0&id=1e316afa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e316afa"]])

export default __exports__